<template >
  <boxDropDown title="Criar Acesso Contador">
    <template class="support-tools">
      <div class="form-group col-md-12 support-tools__warning">
        <span><b>Atenção: </b>Para a criação do acesso contador, todas as empresas selecionadas precisam estar obrigatoriamente em um único banco de dados da MarQ. (exemplo: TTTT, QQQQ e etc).</span>
      </div>
      <div class="form-group col-xs-6 col-sm-6 col-md-6">
        <label for="accountantEmail">Email</label>
        <input type="email" class="form-control" placeholder="Email" id="accountantEmail" name="accountantEmail" v-model="accountantFields.accountantEmail" @blur="checkField(accountantFieldsName[0])">
      </div>
      <div class="form-group col-xs-6 col-sm-6 col-md-6">
        <label for="accountantCPF">CPF</label>
        <input type="text" class="form-control" placeholder="CPF" id="accountantCPF" name="accountantCPF" v-mask="['###.###.###-##']"
          v-model="accountantFields.accountantCPF" @blur="checkField(accountantFieldsName[3])">
      </div>
      <div class="form-group col-xs-6 col-sm-6 col-md-6">
        <label for="accountantName">Nome</label>
        <input type="text" class="form-control" placeholder="Nome" id="accountantName" name="accountantName" v-model="accountantFields.accountantName" @blur="checkField(accountantFieldsName[1])">
      </div>
      <div class="form-group col-xs-6 col-sm-6 col-md-6">
        <label for="accountantPassword">Senha</label>
        <input type="text" class="form-control" placeholder="Senha" id="accountantPassword" name="accountantPassword" @blur="checkField(accountantFieldsName[2])" v-model="accountantFields.accountantPassword">
      </div>
      <div class="form-group col-xs-12 col-sm-12 col-md-12">
        <label for="companyIdToAddAccountant">Insira o(s) ID(s) da(s) empresa(s) em que o contador terá acesso</label>
        <input type="text" class="form-control" v-model="newCompanyId" placeholder="ID" id="companyIdToAddAccountant">
      </div>
      <div v-if="errorMessage" class="text-danger col-xs-12 col-sm-12 col-md-12 text-center spacing-bottom" role="alert">
        {{ errorMessage }}
      </div>
      <div class="form-group col-xs-12 col-sm-12 col-md-12 text-center full-width">
        <button class="btn btn-primary" @click="addCompanyId()">Adicionar empresa</button>
      </div>
      <div class="form-group col-xs-12 col-sm-12 col-md-12 text-center center">
        <div v-for="companyId in companyIds" :key="companyId">
          <div class="company-selected col-xs-12 col-sm-12 col-md-12 full-width">
            <span>{{ companyId }}</span>
            <span v-on:click="removeCompanyId(companyId)" title="Remover da lista">
              <!-- <i class="icon-close"></i> -->
              <ion-icon name="close-outline"/>
            </span>
          </div>
        </div>
      </div>
      <div class="form-group col-xs-12 col-sm-12 col-md-12 text-center full-width">
        <button class="btn btn-primary" :disabled="isDisabled()" @click="handleCreateAccountant()">
          <span v-if="!loadingCreateAccountant">Criar contador</span>
          <span v-else class="loading-btn">
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </span>
        </button>
      </div>
      <!-- <button class="btn btn-primary" @click="handleCreateAccountant()">Criar contador</button> -->
    </template>
  </boxDropDown>
</template>

<script>
  import {
    CONTEXT_COMPANY,
    CREATE_ACCOUNTANT,
  } from "../../../../../urlConfig";
  import {
    REQUEST_SERVICE
  } from "../../../../../requestConfig";
  import {
    ALERT_SERVICE
  } from "../../../../../msgAlertService";
  import boxDropDown from "../../../components/layouts/boxDropDown.vue";

  export default {
    name: "accountant-tool",
    components: {
      boxDropDown
    },
    data() {
      return {
        failRequest: false,
        loadingList: false,
        dataCancel: [],
        showAccountant: false,
        newCompanyId: '',
        companyIds: [],
        errorMessage: '',
        accountantFields: {
          accountantEmail: '',
          accountantName: '',
          accountantPassword: '',
          accountantCPF: ''
        },
        accountantFieldsName: ['accountantEmail', 'accountantName', 'accountantPassword', 'accountantCPF'],
        contentSetting: '',
        loadingCreateAccountant: false
      }
    },
    methods: {
      isDisabled(){
        return this.loadingCreateAccountant;
      },
      getList() {
      },
      openAccountant(){
        this.showAccountant = !this.showAccountant;
      },
      addCompanyId() {
        let newCompanyIdToAdd = this.newCompanyId.trim();
        if(newCompanyIdToAdd.length !== 32){
          this.errorMessage = 'O ID da empresa deve ter 32 caracteres.';
          return
        }
        if(this.companyIds.includes(newCompanyIdToAdd)){
          this.errorMessage = 'A empresa já está inserida na listagem';
          return
        }
        this.companyIds.push(newCompanyIdToAdd);
        this.newCompanyId = '';
        this.errorMessage = '';
      },
      removeCompanyId(companyIdToRemove) {
        const index = this.companyIds.indexOf(companyIdToRemove);
        if (index !== -1) {
          this.companyIds.splice(index, 1);
        }
      },
      handleCreateAccountant(){
        if(!this.isValidFields()){
          return;
        }

        if (this.companyIds.length <= 0){
          this.errorMessage = "Não há empresa vinculada ao contador";
          return;
        }

        let bodyRequest = {
          companyIds: this.companyIds,
          name: this.accountantFields.accountantName.trim(),
          email: this.accountantFields.accountantEmail.trim(),
          password: this.accountantFields.accountantPassword.trim(),
          cpf: this.accountantFields.accountantCPF.trim()
        };

        this.loadingCreateAccountant = true;

        REQUEST_SERVICE.get(`${CONTEXT_COMPANY}${this.companyIds[0]}`).then((response) => {
          this.contentSetting = response.data;
          let bodyRequestJSON = JSON.stringify(bodyRequest);

          REQUEST_SERVICE.requestContext('POST', CREATE_ACCOUNTANT, this.contentSetting, bodyRequestJSON).then((response) => {
            ALERT_SERVICE.swal("Sucesso", "Acesso contador criado com sucesso!", "success");
            this.clearFields();
            this.loadingCreateAccountant = false;
          }).catch((reason) => {
            this.loadingCreateAccountant = false;
            if(reason.response.data.erros.length > 0){
              ALERT_SERVICE.swal("ERRO", reason.response.data.erros[0].value, "error");
            }else{
              ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de desenvolvimento", "error");
            }
          });
        }).catch((reason) => {
          this.loadingCreateAccountant = false;
          ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de desenvolvimento", "error");
        });
      },
      isValidFields(){
        for (const name of this.accountantFieldsName) {
          this.checkField(name);
          if (this.errorMessage !== '') {
            return false;
          }
        }
        return true;
      },
      checkField(nameOfInput){
        if(nameOfInput === this.accountantFieldsName[0]){
          if(!this.isValidEmail(this.accountantFields.accountantEmail.trim())){
            this.errorMessage = "Email inválido";
            return;
          }
        }else if(nameOfInput === this.accountantFieldsName[1]){
          if(this.accountantFields.accountantName.trim() === ''){
            this.errorMessage = "Nome inválido";
            return;
          }else if (this.accountantFields.accountantName.trim().length < 10){
            this.errorMessage = "O nome do contador deve conter pelo menos 10 caracteres";
            return;
          }else if (this.accountantFields.accountantName.trim().split(" ").length == 1){
            this.errorMessage = "O nome do contador deve conter um sobrenome";
            return;
          }
        }else if(nameOfInput === this.accountantFieldsName[2]){
          if(this.accountantFields.accountantPassword.trim().length < 6){
            this.errorMessage = "Senha muito curta";
            return;
          }
        }else if(nameOfInput === this.accountantFieldsName[3]){
          if(!this.isValidCPF(this.accountantFields.accountantCPF.trim())){
            this.errorMessage = "CPF inválido";
            return;
          }
        }
        this.errorMessage= '';
      },
      clearFields(){
        this.accountantFields.accountantEmail = '';
        this.accountantFields.accountantName = '';
        this.accountantFields.accountantPassword = '';
        this.accountantFields.accountantCPF = '';
        this.companyIds = [];
        this.newCompanyId = '';
      },
      isValidEmail(value){
        const regexToValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regexToValidEmail.test(value);
      },
      isValidCPF(value) {
        const cpf = value.replace(/\D/g, '');

        if (cpf.length !== 11) return false;

        if (/^(\d)\1{10}$/.test(cpf)) return false;

        let sum = 0;
        for (let i = 0; i < 9; i++) {
            sum += parseInt(cpf.charAt(i)) * (10 - i);
        }
        let remainder = 11 - (sum % 11);
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cpf.charAt(9))) return false;

        sum = 0;
        for (let i = 0; i < 10; i++) {
            sum += parseInt(cpf.charAt(i)) * (11 - i);
        }
        remainder = 11 - (sum % 11);
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cpf.charAt(10))) return false;

        return true;
      }
    }
  }
</script>

<style lang="scss" scoped>

* {
  font-family: "Montserrat", sans-serif !important;
}

.support-tools {
    &__warning {
      padding: 10px;
      text-align: center;
      background-color: #FFDF8D;
      border-radius: 8px !important;
      color: #FF445D;
    }
  }

.btn-accountant {
  button {
    background: #3598DC;
    color: #FFFFFF;
    text-decoration: none;
    padding: 8px 20px;
    border-radius: 4px !important;
    border: none;
    min-width: 130px;
    font-weight: 600;
    display: inline-block;

    &:hover {
      background-color: #0F77AE;
    }
  }
}

.full-width{
  width: 100% !important;
}

.spacing-bottom{
  margin-bottom: 8px;
}

.company-selected {
  background: #F0F0F0;
  padding: 10px;
  margin-bottom: 15px;

  span {
    &:first-child {
      font-weight: bold;
      color: #201E1E;
      display: block;
      max-width: 190px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    &:last-child {
      font-size: 16px;
      color: #E74A4E;
      float: right;
      cursor: pointer;
      position: absolute;
      right: 22px;
      top: 10px;
    }
  }
}

ul{
  list-style: none;
}

.center{
  margin: auto;
}


</style>


// WEBPACK FOOTER //
// src/vue/pages/restricted/support/supportItems/accountantTool.vue